import { API_URL } from "../../constants/app";
import { headersJsonToken, headersToken } from "./requestHeaders";

export async function getNationalities(payload) {
  let res = await fetch(`${API_URL}/nationality/list`, {
    method: "POST",
    headers: headersJsonToken(),
    body: JSON.stringify(payload),
  })
    .then((res) => res.json())
    .then((data) => {
      let modifiedData = [];
      data.body.data.forEach((nationality, i) => {
        const createdParts = nationality.createdDate?.split(" ")
        const modifiedParts = nationality.modifiedDate?.split(" ") 

        const createdDate = createdParts[0]
        const createdTime = createdParts[1]
        const modifiedDate = modifiedParts?.length ? modifiedParts[0] : undefined 
        const modifiedTime = modifiedParts?.length ? modifiedParts[1] : undefined 
        modifiedData.push({
          n: i + 1,
          id: nationality.id,
          nameInKH: nationality.nameKh,
          nameInEN: nationality.nameEn,
          region: nationality.region,
          createdBy: nationality.createdBy,
          createdDate: createdDate,
          createdTime: createdTime,
          modifiedDate: modifiedDate,
          modifiedTime: modifiedTime,
          modifiedBy: nationality.modifiedBy,
        });
      });
      return modifiedData;
    });
  return res;
}

export async function getInfiniteNationality({ queryKey, pageParam = 1 }) {
  let payload = queryKey[1];
  payload = { page: pageParam, ...payload };
  let res = await fetch(`${API_URL}/nationality/list`, {
    method: "POST",
    headers: headersJsonToken(),
    body: JSON.stringify(payload),
  })
    .then((res) => res.json())
    .then((data) => {
      let modifiedData = [];

      data.body.data?.forEach((nationality, i) => {
        const createdParts = nationality.createdDate?.split(" ")
        const modifiedParts = nationality.modifiedDate?.split(" ") 

        const createdDate = createdParts[0]
        const createdTime = createdParts[1]
        const modifiedDate = modifiedParts?.length ? modifiedParts[0] : undefined 
        const modifiedTime = modifiedParts?.length ? modifiedParts[1] : undefined 
        modifiedData.push({
          n: i + 1,
          id: nationality.id,
          nameInKH: nationality.nameKh,
          nameInEN: nationality.nameEn,
          region: nationality.region,
          createdBy: nationality.createdBy,
          createdDate: createdDate,
          createdTime: createdTime,
          modifiedDate: modifiedDate,
          modifiedTime: modifiedTime,
          modifiedBy: nationality.modifiedBy,
        });
      });
      return { modifiedData, pagination: data.body.pagination };
    });
  return res;
}
export async function deleteNationality(id) {
  let res = await fetch(`${API_URL}/nationality/delete/${id}`, {
    method: "POST",
    headers: headersToken(),
  })
    .then((res) => res.json())
    .then((data) => {
      return data;
    });
  return res;
}
export async function findNationality(id) {
  let res = await fetch(`${API_URL}/nationality/find/${id}`, {
    method: "POST",
    headers: headersJsonToken(),
  })
    .then((res) => res.json())
    .then((data) => {
      let modifiedData = [];
      let nationality = data?.body.data[0];
      modifiedData = {
        nameKh: nationality.nameKh,
        nameEn: nationality.nameEn,
        region: {
          value: nationality.regionId,
          label: nationality.region
        },
      };
      return modifiedData;
    });
  return res;
}
export async function addNationality(payload) {
  let res = await fetch(`${API_URL}/nationality/add`, {
    method: "POST",
    headers: headersJsonToken(),
    body: JSON.stringify(payload),
  })
    .then((res) => res.json())
    .then((data) => {
      return data;
    });
  return res;
}
export async function editNationality(payload) {
  let res = await fetch(`${API_URL}/nationality/update`, {
    method: "POST",
    headers: headersJsonToken(),
    body: JSON.stringify(payload),
  })
    .then((res) => res.json())
    .then((data) => {
      return data;
    });
  return res;
}
